import { Tab, Tabs } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import Helmet from 'react-helmet';
import {
    Portlet,
    PortletBody
} from "../../../partials/content/Portlet";
import { AICreditsUsageReport } from '../AICreditsUsageReportPage';
import { CreditsUsageReport } from '../CreditsUsageReportPage';
import { SystemCreditsUsageReport } from '../SystemCreditsUsageReportPage';
import { CreditAccountUsageReport } from '../CreditAccountUsageReportPage';
const useStyles = makeStyles((theme) => ({
    root: {
        margin: 'auto',
    },
    button: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1),
    },
    tabs: {
        borderBottom: '1px solid #ebedf2' 
    },
    icon: {
        fontSize: 17,
        marginTop: 1,
    }
}));

export default function CreditUsageReportTabPage({userRole,intl}) {

    const [tab, setTab] = React.useState(0);
    const classes = useStyles();

    function a11yProps(index) {
        return {
            id: `vertical-stats-tab-${index}`,
            'aria-controls': `vertical-stats-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setTab(newValue);
    };

    return (
        <>
            <Helmet title="Credit Usage Report" />
            <Portlet>
                <PortletBody>
                    <Tabs
                        value={tab}
                        onChange={handleChange}
                        aria-label="Credit Usage Tab"
                        className={classes.tabs}
                    >
                        <Tab label="Transactions for EAPG" {...a11yProps(0)} />
                        <Tab label="Credits for AI" {...a11yProps(1)} />
                        <Tab label="Credits for System" {...a11yProps(2)} />
                        <Tab label="Transactions for Claim Notes" {...a11yProps(3)} />
                    </Tabs>
                    {tab === 0 && (
                        <>
                            <CreditsUsageReport />
                        </>
                    )}
                    {(tab === 1) && (
                        <>
                            <AICreditsUsageReport />
                        </>
                    )}
                    {(tab === 2) && (
                        <>
                            <SystemCreditsUsageReport />
                        </>
                    )}
                    {tab === 3 && (
                        <>
                            <CreditAccountUsageReport />
                        </>
                    )}
                </PortletBody>
            </Portlet>
        </>
    );
}